/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { FormikInput } from 'components/UiKit/FormikFields';

import { useFormikContext } from 'formik';

const CropZoneAreaInput = ({ boundaryArea = 0, reportedArea = 0 }) => {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (reportedArea === 0) {
      setFieldValue('reportedArea', '');
    } else {
      const roundedRA = (Math.round(reportedArea * 100) / 100).toFixed(2);
      setFieldValue('reportedArea', roundedRA);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportedArea]);

  return (
    <>
      <FormikInput
        name="boundaryArea"
        label="Estimated Boundary Area"
        value={`${boundaryArea} acres`}
        disabled
      />
      <FormikInput name="reportedArea" label="Reported Area" placeholder="--" />
    </>
  );
};

CropZoneAreaInput.propTypes = {
  boundaryArea: PropTypes.number,
  reportedArea: PropTypes.number
};

export default CropZoneAreaInput;
